import React from 'react';
import FaClose from 'react-icons/lib/fa/close';

/**
 * CloseButton displays a commly used 'close' icon.
 * onClick, this button executes a function passed to it.
 * @reactProps {function} handleCloseButton - a function appropriate
 * for a close button. Function will likely be from the parent so actions
 * occur in the correct scope.
 */
export default class CloseButton extends React.Component {
  handleCloseButton = () => {
    this.props.handleCloseButton();
  };

  render() {
    return (
      <div className="close-button">
        <button onClick={this.props.handleCloseButton}>
          <FaClose />
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CloseButton.js